import {
  Component, OnInit, OnDestroy, Renderer2, ElementRef,
  Input, HostBinding, ChangeDetectorRef, ChangeDetectionStrategy,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

import { BrandService } from 'shared/brand/brand.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { SearchModel } from 'shared/search/search.model';
import { statusLookup } from 'shared/my-products/my-products-statuses';
import { DashboardSearchService } from '../dashboard-search.service';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'dashboard-search',
  templateUrl: 'dashboard-search.component.html',
  styleUrls: ['dashboard-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardSearchComponent implements OnInit, OnDestroy {

  searchModel: SearchModel;
  statusId: number;
  name: string = '';
  text: string = '';
  count: number = 0;
  loading: boolean = false;
  brandSubscription: Subscription;
  permissionsSubscription: Subscription;
  isActive: boolean = true;

  @Input() invalid: boolean = false;

  // element size: 'full', 'third', 'quarter'
  @Input()
  set size(size: string) {
    this.setClassName(`size-${size}`);
  }

  @HostBinding('class.ten-million') get tenMillion(): boolean {
    return _.inRange(this.count, 9999999, 100000000);
  }

  @HostBinding('class.large') get large(): boolean {
    return this.count >= 100000000;
  }

  constructor(
    protected brandService: BrandService,
    protected permissionsService: PermissionsService,
    protected searchService: DashboardSearchService,
    protected router: Router,
    protected _renderer: Renderer2,
    protected ref: ChangeDetectorRef,
    public elementRef: ElementRef,
  ) {}

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    this.initSearchModel();
    this.refresh();
    this.subscribeToBrandChange();
    this.subscribeToPermissionsChange();
  }

  ngOnDestroy() {
    this.isActive = false;
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

   get isAllowedLink() {
     return this.hasPermission(['catalog-edit', 'admin']);
   }

   get link(): string {
     return '';
   }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public hasPermission(allow: Array<string>|string, requireAll: boolean= false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

  /*******************************************
   * COMPONENT PROTECTED METHODS
   *******************************************/

  protected initSearchModel() {
    console.log('initSearchModel no impemented');
  }

  protected setData(data: any) {
    console.log('setData not implemented.');
  }

  protected setClassName(className: string) {
    this._renderer.addClass(this.elementRef.nativeElement, className);
  }

  protected refresh() {
    this.loading = true;
    this.searchService.runSearch(this.brandService.getBrand(), this.searchModel)
    .subscribe((data: any) => {
      this.setData(data);
      this.ref.markForCheck();
      this.loading = false;
    });
  }

  protected navigateToPage() {
    this.searchModel.itemsPerPage = 25;
    const sm = JSON.stringify(this.searchModel);
    if (this.link) {
      this.router.navigate([this.link], { queryParams: {sm}});
    } else {
      console.log('link parameter is not implemented!');
    }
  }

  protected updateStatusModel(data: any) {
    if (data.statuses) {
      const status = _.find(data.statuses, {id: this.statusId});
      if (status) {
        // @ts-ignore
        this.searchModel.statusModel = status;
        this.searchModel.statusModel.name = _.get(_.find(statusLookup, ['id', this.statusId]), 'status', '');
      }
    }
  }

  protected subscribeToBrandChange() {
    this.brandSubscription = this.brandService.brandChange
      .pipe(takeWhile(() => this.isActive))
      .subscribe(brand => {
        this.refresh();
      });
  }

  protected subscribeToPermissionsChange() {
    this.permissionsSubscription = this.permissionsService.permissionsChange
      .pipe(takeWhile(() => this.isActive))
      .subscribe(() => {
        this.ref.markForCheck();
      });
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onViewProductsClick() {
    if (this.hasPermission(['catalog-view', 'catalog-edit', 'admin', 'repository', 'fitments'])) {
      this.navigateToPage();
    }
  }
}
